export function pdfUrlHideScrollbar (url) {
  return `${url}#scrollbar=0`
}
